export enum ActionType {
  Assign = "assign",
  FeedbackRequest = "feedbackRequest",
  FollowUp = "followUp",
  Message = "message",
  PrivateNote = "privateNote",
  Status = "status",
  Priority = "priority",
  AddTags = "addTags",
  RemoveTags = "removeTags",
  Spam = "spam",
  Unspam = "unspam",
  AddFollowers = "addFollowers",
  RemoveFollowers = "removeFollowers",
}
